import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { locationFaq, locationNames } from '../data/locationFaq';

// FAQ-блок для страниц локаций: видимые вопросы-ответы + FAQPage JSON-LD
// + перелинковка на остальные локации. Данные — src/data/locationFaq.js.
export const LocationFAQ = ({ location }) => {
  const { language } = useLanguage();
  const data = locationFaq[location];
  const name = locationNames[location];
  if (!data || !name) return null;

  const isRu = language === 'ru';
  const items = isRu ? data.ru : data.en;
  const prefix = isRu ? '/ru' : '';

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((it) => ({
      '@type': 'Question',
      name: it.q,
      acceptedAnswer: { '@type': 'Answer', text: it.a },
    })),
  };

  const others = Object.keys(locationNames).filter((slug) => slug !== location);

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">
            {isRu ? `Частые вопросы о VPS ${name.ruPrep}` : `VPS in ${name.en} — FAQ`}
          </h2>
          <div className="space-y-5">
            {items.map((it, i) => (
              <div key={i} className="bg-white rounded-lg border border-gray-200 p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{it.q}</h3>
                <p className="text-gray-600 leading-relaxed">{it.a}</p>
              </div>
            ))}
          </div>
          <p className="mt-10 text-sm text-gray-500 leading-relaxed">
            <span className="font-medium text-gray-700">
              {isRu ? 'Другие локации: ' : 'Other locations: '}
            </span>
            {others.map((slug, i) => (
              <React.Fragment key={slug}>
                {i > 0 && ' · '}
                <Link to={`${prefix}/${slug}`} className="text-blue-700 hover:underline">
                  {isRu ? locationNames[slug].ru : locationNames[slug].en}
                </Link>
              </React.Fragment>
            ))}
          </p>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
          />
        </div>
      </div>
    </section>
  );
};
